module.exports = __webpack_public_path__ + "static/media/jquerymobile.03c56eb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jquerymobile.png
// module id = 128
// module chunks = 0